var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sys-edit" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formSys",
            staticClass: "dialog-body-modal",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "flex-wrap": "wrap"
            },
            attrs: {
              "label-position": "top",
              model: _vm.formSys,
              rules: _vm.rules,
              "label-width": "140px"
            }
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: { width: "224px" },
                attrs: { label: "系统编号", prop: "systemId" }
              },
              [
                _c("el-input", {
                  staticClass: "limit32",
                  attrs: {
                    size: "small",
                    placeholder: "请输入系统编号",
                    maxlength: "32",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.formSys.systemId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "systemId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.systemId"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: { width: "224px" },
                attrs: { label: "系统名称", prop: "systemName" }
              },
              [
                _c("el-input", {
                  staticClass: "limit32",
                  attrs: {
                    size: "small",
                    placeholder: "请输入系统名称",
                    maxlength: "32",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.formSys.systemName,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "systemName",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.systemName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: { width: "224px" },
                attrs: { label: "是否是公共系统", prop: "isPublicResource" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      placeholder: "请选择是否是公共系统"
                    },
                    model: {
                      value: _vm.formSys.isPublicResource,
                      callback: function($$v) {
                        _vm.$set(_vm.formSys, "isPublicResource", $$v)
                      },
                      expression: "formSys.isPublicResource"
                    }
                  },
                  [
                    _c("el-option", { attrs: { label: "否", value: 0 } }),
                    _c("el-option", { attrs: { label: "是", value: 1 } })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer", staticStyle: { "margin-top": "0px" } },
      [
        _c(
          "el-button",
          { staticClass: "btn", on: { click: _vm.cancelDailog } },
          [_vm._v("取消")]
        ),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.ifSysEdit ? "确认修改此系统？" : "确认添加此系统"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c("input", {
              staticClass: "btn btn-red",
              attrs: { slot: "reference", type: "button", value: "确认" },
              slot: "reference"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }